export default [
  {
    path: '/funds/:fundId',
    name: 'fundDetails',
    component: () => import(/* webpackChunkName: "fund" */ './views/FundView.vue'),
  },
  {
    path: '/funds',
    name: 'fundsList',
    component: () => import(/* webpackChunkName: "fund" */ './views/FundsListView.vue'),
  },
];
